import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCalibration } from 'app/dtos/calibration/createCalibration';
import { UpdateCalibration } from 'app/dtos/calibration/updateCalibration';
import { _isPersonId } from 'app/services/auth.service';
import { CalibrationReferenceDevicesService } from 'app/services/models/calibration-reference-devices.service';
import { CalibrationService } from 'app/services/models/calibration.service';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import { CertificateService } from 'app/services/models/certificate.service';
import { DeviceService } from 'app/services/models/device.service';
import { EnvironmentalConditionService } from 'app/services/models/environmental-condition.service';
import { PersonService } from 'app/services/models/person.service';
import { ProcedureService } from 'app/services/models/procedure.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import htmlToPdfmake from 'html-to-pdfmake';
import * as pdfjsLib from 'pdfjs-dist';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import QRCode from 'qrcode';
import { CoreConfigService } from '@core/services/config.service';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { CalibrationlogoEnum } from 'app/enum/calibrationlogoEnum';
import { CalibrationData, CalibrationPage2, headerBilgileri, Reference } from '../create-certificate-dialog/create-certificate-dialog.component';
import { PdfFontService } from 'app/services/common/pdf-font.service';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { TurkakService } from 'app/services/api/turkak.service';
import { CalibrationCertificate } from 'app/services/api/apiDtos/CalibrationCertificate';
import { UpdateDeviceDialogComponent } from '../update-device-dialog/update-device-dialog.component';
import { GetCustomerSettingDetailDTO } from 'app/dtos/customer-setting/getCustomerSettingDetailDTO';
import { CustomerSettingService } from 'app/services/models/customer-setting.service';
import { CertificateReservationDialogComponent } from '../certificate-reservation-dialog/certificate-reservation-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ControllerType, HttpClientService } from 'app/services/http-client.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MeasurementResultService } from 'app/services/models/measurement-result.service';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;  // ✅ Doğru
(pdfMake as any).fonts = {
  RobotoSerif: {
    normal: 'RobotoSerif-Regular.ttf', // Add the font path to the VFS here
    bold: 'RobotoSerif-Medium.ttf',      // Add the font path to the VFS here
    italics: 'RobotoSerif-Italic.ttf', // Add the font path to the VFS here
    bolditalics: 'RobotoSerif-BoldItalic.ttf', // Add the font path to the VFS here
  },
  Roboto: { // 🔄 Roboto diye alias ekleyebilirsin
    normal: 'RobotoSerif-Regular.ttf',
    bold: 'RobotoSerif-Bold.ttf',
    italics: 'RobotoSerif-Italic.ttf',
    bolditalics: 'RobotoSerif-BoldItalic.ttf',
  }
};

@Component({
  selector: 'app-update-calibration-dialog',
  templateUrl: './update-calibration-dialog.component.html',
  styleUrls: ['./update-calibration-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateCalibrationDialogComponent implements OnInit {
  @Input() data;
  constructor(public activeModal: NgbActiveModal,
    private calibrationService: CalibrationService,
    private procedureService: ProcedureService,
    private personService: PersonService,
    private deviceService: DeviceService,
    private toastrService: ToastrService,
    private router: Router,
    private environmentalConditionService: EnvironmentalConditionService,
    private calibrationReferenceDeviceService: CalibrationReferenceDevicesService,
    private certificateService: CertificateService,
    private fb: FormBuilder,
    private certificateReservationService: CertificateReservationService,
    private _coreConfigService: CoreConfigService,
    private pdfFontService: PdfFontService,
    private turkakService: TurkakService,
    private modalService: NgbModal,
    @Inject('backendUrl') private backendUrl: string,
    private customerSettingService: CustomerSettingService,
    private httpClientService: HttpClientService,
    private sanitizer: DomSanitizer,
    private measurementResultService: MeasurementResultService
  ) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
    this._unsubscribeAll = new Subject();

  }
  private _unsubscribeAll: Subject<any>;
  public coreConfig: any;
  certificateFirstNo: string = null;

  calibration: any = {};
  calibrationDevice: any = {};
  procedures: any[] = [];
  kindProcedures: any[] = []
  selectProcedureId: number;
  selectProcedure: any = {};
  public basicPwdShow = false;
  refereceDevices: any[] = [];
  persons: any[] = [];
  selectedPersonId: number = null;

  certificateForm: FormGroup; // Form için tanımlama
  certificate: any = null;
  certificateNumber: string = null;

  selectedDevices: any[] = [];
  selectedDevice: any;

  date = new Date();
  date2 = new Date();

  calibrationAddress: string = '';

  certificateIssuedate = new Date();
  certificateExpiryDate = moment().add(1, 'year').toDate();
  certificateReviseDate = new Date();

  environmentalContent: any[] = [];
  enviromentalContentId: number;
  isPdfDoc: boolean = false;

  isPlace: boolean = true;
  certificateReservations: any[] = [];

  pdfUrl: SafeResourceUrl | null = null;

  measurementResults: any[] = [];
  selectMeasurementId: number = null;

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  public dateTimereviseStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimereviseEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeReviseOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  selectedAcradtionOrganizationId = 1;
  akradetionOrganization = [
    { id: 1, name: "Türkak" },
    { id: 2, name: "NAC" },
    { id: 3, name: "İzlenebilirik" },
    { id: 4, name: "IAS" }
  ]
  async ngOnInit() {
    this.certificateForm = this.fb.group({
      certificateNo: [this.certificateNumber],
      issueDate: ['', Validators.required],
      expiryDate: ['', Validators.required],
      visualAndFunctional: [true],
      reviseDescription: [null],
      reviseDate: ['', Validators.required],
      isPrivateResiveNo: [true],
      isPrivateResiveDescription: [false],
      personId: [null, Validators.required],
    });
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      console.log(this.coreConfig);
    });
    this.certificateFirstNo = this.coreConfig.certificateFirstNo;
    await this.getByIdCalibration(this.data);
    if (this.coreConfig.isCalibratedTurkak == true && this.calibration.companyTurkakId == null && this.selectedAcradtionOrganizationId == 1)
      this.toastrService.error("Bu firma Türkak'ta kayıtlı değil", "Türkak Firma");
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getByIdCalibration(id) {
    const data = await this.calibrationService.getByIdCalibration(id);
    console.log(data);
    this.calibration = data;
    if (this.calibration) {
      await this.getByIdReadyCalibration(this.calibration.id);
      const kindId = this.calibration.deliveryDevice?.kindId; // kindId'yi tanımla
      console.log("kindId:", kindId);

      await this.getAllEnvironmentalCondition(kindId);
      await this.getAllProcedure();
      await this.getAllPerson(['calibratedConfirming']);
      await this.getAllPerson(['calibratonperson']);
      await this.getAllReferenceDevice(kindId);
      await this.getByKindIdProcedures(kindId);
      await this.getByIdCertificate(this.calibration.certificateId);
      this.date = new Date(this.calibration.calibrationDate);
      this.enviromentalContentId = this.calibration.environmentalCondition.id
      this.isPlace = this.calibration.isPlace;
      this.selectProcedureId = this.calibration.procedureId;
      this.selectedAcradtionOrganizationId = this.calibration.accreditationOrganization;
      this.selectedPersonId = this.calibration.personId;
      this.date2 = this.calibration.acceptanceDate != null ? new Date(this.calibration.acceptanceDate) : null
      if (this.calibration2.calibrationReferencesDevices?.length) {
        this.calibration2.calibrationReferencesDevices.forEach(element => {
          const device = this.refereceDevices.find(p => p.id === element.deviceId);
          if (device) {
            const devices = {
              ReferenceDeviceId: element.id,
              ...device
            };
            this.onDeviceSelect(devices);
          }
        });
      }

      if (this.pdfDoc == null) {
        //await this.getLastCertificatePdfBuffer(this.certificate.id);
        let path = null;
        if (this.calibration.deliveryDevice.seriNo != null)
          path = this.calibration.deliveryDevice.seriNo + "-" + this.calibration.deliveryDevice.code + "-" + this.calibration.deliveryDevice.deliveryCode;
        else
          path = this.calibration.deliveryDevice.code + "-" + this.calibration.deliveryDevice.deliveryCode;


        const lastMeasurementFile = [...this.certificate.certificateRevises]
          .reverse()
          .find(p => p.is_MeasurementFile === true);

        // 🔥 varsa no'yu path'in sonuna ekle
        if (lastMeasurementFile?.no != null) {
          path = `${path}-${lastMeasurementFile.no}`;
        }

        console.log(path);
        await this.getCalibrationMeasurementResultBase64(path);
      }
    }
  }

  onPlaceChange(value: boolean) {
    this.isPlace = value;
    this.calibrationAddress = this.calibration2?.placeAddress || '';
  }

  calibration2: any;
  async getByIdReadyCalibration(id) {
    const data = await this.calibrationService.getByIdReadyCalibration(id);
    console.log(data);
    this.calibration2 = data;
    this.akradetionOrganization = this.akradetionOrganization.filter(p => p.id == this.calibration2.acraditionCompanyId || p.id == 3)

    this.onPlaceChange(this.calibration2.isPlace);
    await this.getAllMeasurementResults(this.calibration.deliveryDevice.kindId, this.calibrationDevice.referenceId);

  }

  async getAllMeasurementResults(kindId: number, referenceId?: number) {
    const data = await this.measurementResultService.getByKindMeasurementResult(kindId, referenceId);
    console.log(data);
    this.measurementResults = data.map(x => {
      return {
        ...x,
        fileName: this.getFileName(x.fileName) // buraya yazıyoruz ✔️
      };
    });
    if (this.measurementResults.length == 1) {
      this.selectMeasurementId = this.measurementResults[0]?.id;
    }
  }

  getFileName(i: string): string {
    const file: any = i; // 👈 burada tipini 'any' yaptık

    if (!file) return '';

    // 🟢 2. Backend’den gelen string path
    if (typeof file === 'string') {
      // 'procedures/....-dosya-adi.pdf'
      const fileName = file.split('/').pop() || '';
      const parts = fileName.split('-');
      // 🟢 5. tireden sonrasını al
      return parts.length > 5 ? parts.slice(5).join('-') : fileName;
    }

    // 🟡 3. Diğer tüm durumlar
    return '';
  }

  async downloadSelectedFile() {
    if (!this.selectMeasurementId) return;

    const selected = this.measurementResults.find(x => x.id === this.selectMeasurementId);
    const originalFileName = selected.fileName;
    const extension = originalFileName.substring(
      originalFileName.lastIndexOf('.')
    );

    if (!selected || !selected.filePath) {
      console.warn("Dosya bulunamadı");
      return;
    }

    const loadingToast = this.toastrService.info(
      'Dosya indiriliyor, lütfen bekleyin...',
      'İndirme',
      {
        disableTimeOut: true,
        closeButton: false,
        progressBar: true
      }
    );

    try {
      const references = this.selectedDevices?.map(device => ({
        deviceName: device.deviceName,
        serialNumber: device.seriNo,
        acceptanceCriterion: device?.referenceDeviceMovement?.acceptanceCriterion,
        calibrationCertificateUncertainty:
          device?.referenceDeviceMovement?.calibrationCertificateUncertainty
      }));

      const deviceInfo = {
        deviceName: this.calibration2.deviceName,
        seriNo: this.calibration2.deviceSeriNo,
        resolution: this.calibration2.deviceResolution,
        inventoryNumber: this.calibration.deliveryDevice.inventoryNumber,
        kindName: this.calibration.deliveryDevice.kindTypeName
      };

      const companyInfo = {
        companyName: this.calibration2.certficateCompany,
        companyAdres: this.calibration2.certificateCompanyAddress
      };

      const fileName =
        `${this.calibration.deliveryDevice.seriNo ? this.calibration.deliveryDevice.seriNo + '-' : ''}` +
        `${this.calibration.deliveryDevice.code}-${this.calibration.deliveryDevice.deliveryCode}`;

      const blob = await this.measurementResultService.downloadMeasurementFile(
        selected.id,
        selected.fileName,
        references,
        fileName,
        companyInfo,
        deviceInfo
      );

      // ⬇ Dosyayı indir
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = fileName + extension; // 🔥 dinamik uzantı
      a.click();
      URL.revokeObjectURL(a.href);

      // ✅ Loading toastr kapat
      this.toastrService.clear(loadingToast.toastId);

      // ✅ Başarılı toastr
      this.toastrService.success('Dosya başarıyla indirildi', 'Tamam');

    } catch (error) {
      console.error(error);

      // ❌ Loading toastr kapat
      if (loadingToast) {
        this.toastrService.clear(loadingToast.toastId);
      }

      // ❌ Hata toastr
      this.toastrService.error(
        'Dosya indirilemedi, lütfen tekrar deneyin',
        'Hata'
      );
    }
  }

  onSubmit() { }

  async getAllCertificateReservations(companyId) {
    console.log(companyId);
    const data = await this.certificateReservationService.getByIdCompanyCertificateReservations(companyId);
    this.certificateReservations = data;
    console.log(this.certificateReservations);
  }

  reserveCert: any;
  onReservationSelect(reservation: any) {
    console.log(reservation);
    if (reservation) {
      const reserverCertificateNo = reservation.reservedCertificateNo;
      this.reserveCert = reservation;
      let newCertificateNo = this.certificate.certificateNo;
      console.log(this.certificate.certificateRevises);
      console.log(newCertificateNo);
      if (!this.certificate.certificateRevises || this.certificate.certificateRevises.length === 0) {
        // Hiç revize yoksa R1 ekle
        newCertificateNo += '-R01';
      } else {
        // Revizeler varsa en son revizenin no'sunu al
        const lastRevise = this.certificate.certificateRevises[this.certificate.certificateRevises.length - 1];
        const lastReviseNo = lastRevise.no; // örnek: "R01"
        const match = lastReviseNo?.match(/R(\d+)/); // "R01" → 1
        if (match) {
          const lastNumber = parseInt(match[1], 10);
          const nextNumber = lastNumber + 1;
          const paddedNumber = nextNumber.toString().padStart(2, '0'); // "2" → "02"
          newCertificateNo = `${reserverCertificateNo}-R${paddedNumber}`;
        } else {
          // Geçerli formatta değilse R1’den başlat
          newCertificateNo += '-R01';
        }
      }
      console.log(newCertificateNo);
      console.log(reserverCertificateNo);

      this.certificateNumber = reserverCertificateNo;
      console.log(this.certificateNumber);

      this.certificateForm.patchValue({
        certificateNo: reserverCertificateNo,
      });
    }
  }

  addReservation() {
    const modal = this.modalService.open(CertificateReservationDialogComponent, {
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      companyId: this.calibration.deliveryDevice?.certficateCompanyId,
      data: null
    };
    modal.result.then(async (result) => {
      if (result == true) {
        await this.getAllCertificateReservations(this.calibration.deliveryDevice?.certficateCompanyId);
        this.onReservationSelect(this.certificateReservations[this.certificateReservations?.length - 1])
      }
    })
  }

  async getByIdCertificate(id) {
    const data = await this.certificateService.getByIdCertificate(id);
    console.log(data);
    this.certificate = data;
    this.certificateExpiryDate = new Date(this.certificate.expiryDate);
    this.certificateIssuedate = new Date(this.certificate.issueDate);
    let newCertificateNo = this.certificate.certificateNo;
    await this.getAllCertificateReservations(this.calibration.deliveryDevice?.certficateCompanyId)

    if (!this.certificate.certificateRevises || this.certificate.certificateRevises.length === 0) {
      // Hiç revize yoksa R1 ekle
      newCertificateNo += '-R01';
    } else {
      // Revizeler varsa en son revizenin no'sunu al
      const lastRevise = this.certificate.certificateRevises[this.certificate.certificateRevises.length - 1];
      const lastReviseNo = lastRevise.no; // örnek: "R01"

      const match = lastReviseNo?.match(/R(\d+)/); // "R01" → 1

      if (match) {
        const lastNumber = parseInt(match[1], 10);
        const nextNumber = lastNumber + 1;
        const paddedNumber = nextNumber.toString().padStart(2, '0'); // "2" → "02"
        newCertificateNo = `${this.certificate.certificateNo}-R${paddedNumber}`;
      } else {
        // Geçerli formatta değilse R1’den başlat
        newCertificateNo += '-R01';
      }
    }

    this.certificateNumber = newCertificateNo;

    const lastRevise =
      this.certificate?.certificateRevises?.length
        ? this.certificate.certificateRevises[this.certificate.certificateRevises.length - 1]
        : null;

    this.certificateForm.patchValue({
      certificateNo: this.certificate.certificateNo,
      personId: this.certificate.personId,
      isPrivateResiveDescription: lastRevise?.isEyeDescription ?? false,
      isPrivateResiveNo: lastRevise?.isEyeReviseNo ?? true,
      visualAndFunctional: this.calibration2.visuanAndFunctional
    });
  }

  async getAllEnvironmentalCondition(kindId) {
    const data = await this.environmentalConditionService.getAllEnvironmentalCondition(0, 100, kindId);
    console.log(data);
    this.environmentalContent = data.environmental;

    this.enviromentalContentId = this.environmentalContent[0]?.id

  }

  async getAllProcedure() {
    const data = await this.procedureService.getAllProcedures(0, 3);
    this.procedures = data.procedures;
  }

  async getByKindIdProcedures(kindId) {
    const data = await this.procedureService.getByKindIdProcedures(kindId);
    this.kindProcedures = data;
    console.log(this.kindProcedures);

  }

  calCompanyPerson = [];
  async getAllPerson(codes?: string[]) {
    const data = await this.personService.getAllCompaniesPersons(0, 500, 1, codes);
    console.log(data);
    if (codes.includes("calibratonperson")) {
      this.calCompanyPerson = data.persons.map(person => ({
        ...person,
        fullName: person.name + ' ' + person.lastName
      }));
      // if (this.calCompanyPerson?.length === 1) {
      //   this.certificateForm.patchValue({
      //     personId: this.calCompanyPerson[0].id
      //   })
      // }
    }
    if (codes.includes("calibratedConfirming")) {
      this.persons = data.persons.map(person => ({
        ...person,
        fullName: person.name + ' ' + person.lastName
      }));
      const pers = this.persons?.find(p => p.id === Number(_isPersonId));
      // if (pers != null)
      //   this.selectedPersonId = pers?.id ?? null;

      // this.selectedPersonId = this.persons[0]?.id
    }
  }

  async getAllReferenceDevice(kindId) {
    const data = await this.deviceService.getAllDevices(0, 1000, '', 1, kindId);
    console.log(data);
    this.refereceDevices = data.devices;
  }

  updateDeviceModal(id) {
    const modal = this.modalService.open(UpdateDeviceDialogComponent, {
      windowClass: 'modal modal-warning',
      centered: true,
      size: 'lg'
    });
    modal.componentInstance.data = {
      id: id,
      isReferenceDevice: false
    };
    modal.result.then(async () => {
      await this.getByIdCalibration(this.data.id);
    });
  }

  async onDeviceSelect(device: any) {
    if (!device) return;

    // Eğer cihaz zaten listede varsa uyarı ver
    const isAlreadySelected = this.selectedDevices.some(d => d.id === device.id);
    if (isAlreadySelected) {
      this.toastrService.warning("Bu cihaz zaten listeye eklenmiş!");
      this.selectedDevice = null;
      return;
    }

    // Eğer cihazın kalibrasyonu geçerliyse listeye ekle
    if (device.isCalibrationValid) {
      const isFromCalibration = this.calibration.calibrationReferenceDevices.some(
        (c) => c.deviceId === device.id
      );
      if (isFromCalibration) {
        this.selectedDevices.push(device);
        return;
      } else {
        //this.toastrService.info("backende istek at")
        const modal = this.modalService.open(ConfirmDialogComponent,
          {
            size: 'sm',
            windowClass: 'modal modal-success',
            centered: true
          }
        );
        modal.componentInstance.data = {
          title: 'Referans Cihaz Ekleme Onayı',
          message: `${device.deviceName} referans cihaz olarak eklemek istediğinizden emin misiniz?`
        };
        modal.result.then(async (result) => {
          if (result) {
            const data = await this.calibrationReferenceDeviceService.calibrationReferenceDevices(device.id, this.calibration.id);
            if (data.status) {
              this.selectedDevices.push(device);
              this.toastrService.success(data.message);
              await this.getByIdReadyCalibration(this.calibration2.id);
            } else {
              this.toastrService.error(data.message);
            }
          }
        });
      }

      //this.selectedDevices.push(device);

    } else {
      this.toastrService.error("Bu cihazın kalibrasyon durumu pasif, bu yüzden referans cihaz olarak ekleyemezsin.");
    }
    this.selectedDevice = null;
  }

  async onReferenceDeviceDeleted(referenceDeviceId: number) {
    // Backend’den sildikten sonra, frontend listeden de sil
    this.selectedDevices = this.selectedDevices.filter(d => d.ReferenceDeviceId !== referenceDeviceId);
    await this.getByIdReadyCalibration(this.calibration2.id);
    // Yeniden veri almak istersen:
    //await this.getByIdCalibration(this.calibration.id); // opsiyonel
  }

  isPdfDocDetail() {
    this.isPdfDoc = !this.isPdfDoc;
  }

  isSaveDisabled(): boolean {
    return !this.enviromentalContentId || !this.selectProcedureId || !this.date ||
      !this.selectedPersonId || !this.selectedAcradtionOrganizationId || this.selectedDevices?.length < 1;
  }

  formatTurkakDate(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  // Tarih + saat formatı:
  formatTurkakDateTime(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ` +
      `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  }


  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('Base64 dönüşüm hatası'));
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  }

  turkakQrBase64;
  certificationBodyDocumentNumber: string = null;
  async saveData() {
    console.log(this.certificateForm.value);
    let turkakCalibrationId: string | null = null;
    const person = this.persons.find(p => p.id == this.selectedPersonId);
    turkakCalibrationId = this.calibration2.turkakCalibrationId;
    const calibrationDate = this.date[0] ?? this.date;
    const firstReleaseDate = this.certificateForm.value.issueDate?.[0] ?? this.certificateForm.value.issueDate;
    const serialNumbers = this.selectedDevices.map(ref => ref.seriNo).join(',');

    const turkakPayload: CalibrationCertificate[] = [{
      ID: turkakCalibrationId,
      CustomerID: this.calibration.companyTurkakId,
      CalibrationDate: this.formatTurkakDateTime(calibrationDate), // 👈 string olarak ve doğru formatta
      CalibrationLocation: this.calibrationAddress, //this.isPlace ? 'Yerinde' : 'Laboratuvarda',
      DeviceSerialNumber: this.calibration2.deviceSeriNo,
      MachineOrDeviceType: this.calibration2.deviceType,
      FirstReleaseDateOfTheDocument: this.formatTurkakDate(firstReleaseDate), // 👈 string
      PersonnelPerformingCalibration: `${person.name} ${person.lastName}`,
      // CertificationBodyDocumentNumber:`${this.certificationBodyDocumentNumber}`,
      SerialNumberOfReferenceCalibrator: serialNumbers,
      RevisionDate: this.formatTurkakDate(this.certificateForm.value.reviseDate[0] ?? this.certificateForm.value.reviseDate),
      RevisionNote: 'Güncelleme',
      State: 1
    }];


    console.log(turkakPayload);
    if (this.coreConfig.isCalibratedTurkak && this.selectedAcradtionOrganizationId === 1) {
      try {
        const turkakResponse = await this.turkakService.saveCertificates(turkakPayload);
        console.log('TÜRKAK yanıtı:', turkakResponse);

        if (turkakResponse?.Item1?.length > 0) {
          turkakCalibrationId = turkakResponse.Item1[0].ID
          console.log(turkakCalibrationId);
          let turkakCertificate = null;
          const maxRetries = 8;  // toplam deneme sayısı
          const delayMs = 3000;  // 5 saniye bekleme
          //const turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);

          /*  for (let attempt = 1; attempt <= maxRetries; attempt++) {
              turkakCertificate = await this.turkakService.getCertificate(turkakCalibrationId);
              console.log(`TÜRKAK sertifika deneme ${attempt}:`, turkakCertificate);
  
              if (turkakCertificate?.CertificationBodyDocumentNumber) {
                console.log('CertificationBodyDocumentNumber bulundu ✅');
                break;
              }
  
              if (attempt < maxRetries) {
                console.log(`CertificationBodyDocumentNumber henüz gelmedi, ${delayMs / 1000} saniye bekleniyor...`);
                await new Promise(resolve => setTimeout(resolve, delayMs));
              }
            }
  
            if (!turkakCertificate?.CertificationBodyDocumentNumber) {
              this.toastrService.warning(
                "CertificationBodyDocumentNumber bilgisi henüz TÜRKAK sisteminden alınamadı.",
                "TÜRKAK Uyarısı"
              );
              return; // devam etmiyoruz çünkü bilgi eksik
            }
 
 
          console.log(turkakCertificate);
          if (turkakCertificate != null) {
            this.certificationBodyDocumentNumber = turkakCertificate.CertificationBodyDocumentNumber;
            const certID = turkakCertificate.ID;
            const tbdsNumber = turkakCertificate.TBDSNumber;
            const qrBlob = await this.turkakService.getCertificateQrPng(certID, tbdsNumber); // URL: /GetQR/{certID}/{tbdsNumber}
            this.turkakQrBase64 = await this.convertBlobToBase64(qrBlob);
          }
            */
        } else if (turkakResponse?.Item2?.length > 0) {
          turkakResponse.Item2.forEach((item: any) => {
            this.toastrService.error(item.ErrorDescription || 'TÜRKAK hatası oluştu.');
          });
          return;
        } else {
          this.toastrService.error('TÜRKAK servisi boş bir yanıt döndü.');
          return;
        }
      } catch (error) {
        console.error('TÜRKAK isteği hatası:', error);
        this.toastrService.error('TÜRKAK servisine bağlanırken hata oluştu.');
        return;
      }
    }
    else if (this.selectedAcradtionOrganizationId == 3) {
      const turkakPayload: CalibrationCertificate[] = [{
        ID: turkakCalibrationId,
        CustomerID: this.calibration.companyTurkakId,
        CalibrationDate: this.formatTurkakDateTime(calibrationDate), // 👈 string olarak ve doğru formatta
        CalibrationLocation: this.calibrationAddress, //this.isPlace ? 'Yerinde' : 'Laboratuvarda',
        DeviceSerialNumber: this.calibration2.deviceSeriNo,
        MachineOrDeviceType: this.calibration2.deviceType,
        FirstReleaseDateOfTheDocument: this.formatTurkakDate(firstReleaseDate), // 👈 string
        PersonnelPerformingCalibration: `${person.name} ${person.lastName}`,
        // CertificationBodyDocumentNumber:`${this.certificationBodyDocumentNumber}`,
        SerialNumberOfReferenceCalibrator: serialNumbers,
        // RevisionDate: this.formatTurkakDate(this.certificateForm.value.reviseDate[0] ?? this.certificateForm.value.reviseDate),
        // RevisionNote: 'Silindi',
        State: 0
      }];
      const turkakResponse = await this.turkakService.saveCertificates(turkakPayload);
      if (turkakResponse.Item1[0]) {
        turkakCalibrationId = null;
      }
    }
    else {
      if (this.calibration.companyTurkakId == null && this.selectedAcradtionOrganizationId == 1 && this.calibration2.turkakCalibrationId != null)
        this.toastrService.error("Bu firma Türkak'ta kayıtlı değil", "Türkak Firma");
    }

    //this.turkakQrBase64 = await this.convertImageToBase64('/assets/logo/turkakqr2.png')

    const update = new UpdateCalibration();
    update.id = this.calibration.id;
    update.procedureId = this.selectProcedureId;
    update.personId = this.selectedPersonId;
    update.calibrationDate = this.date[0] ?? this.date;
    update.status = this.calibration.status;
    update.environmentalConditionId = this.enviromentalContentId;
    update.accreditationOrganization = this.selectedAcradtionOrganizationId;
    update.isPlace = this.isPlace;
    update.acceptanceDate = this.date2[0] ?? this.date2;
    update.placeAddress = this.calibrationAddress;
    update.turkakCalibrationId = turkakCalibrationId;
    update.visualAndFunctional = this.certificateForm.value.visualAndFunctional;
    update.measurementFile = this.selectedFile;
    update.saveFilePath = this.saveFilePath;
    console.log(update)
    const data = await this.calibrationService.updateCalibration(update);
    if (data.status) {
      this.closeModal();
      this.calibrationService.sendEvent(true);
      await this.pdfDetail(true);
    } else {
      this.toastrService.error(data.message);
    }
  }

  currentPage = 1;  // İlk sayfa
  totalPages = 0;
  pdfDoc: any = null; // PDF dosyasını tutacak
  img: string[] = [];
  pageCount: number = 2;
  pdfBuffer: boolean = false;
  clearFile(): void {
    this.pdfDoc = null; // Dosya adını null yaparak dosyayı "silmiş" oluyorum
    const input = document.getElementById('customFile') as HTMLInputElement;
    if (input) {
      input.value = ''; // Input değerini sıfırlıyoruz
    }
  }

  async getLastCertificatePdfBuffer(id) {
    console.log(id);
    const data: ArrayBuffer = await this.certificateService.getLastCertificatePdf(id);
    console.log(data);

    const typedArray = new Uint8Array(data);

    const pdf = await pdfjsLib.getDocument(typedArray).promise;
    this.pdfDoc = pdf;
    this.totalPages = pdf.numPages;

    const canvasArray: string[] = [];
    const container = document.getElementById('pdf-container');
    if (container) {
      container.innerHTML = '';
    }

    this.showPdfInIframe(data);

    // İlk iki sayfayı atla
    for (let pageNum = 3; pageNum <= this.totalPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const scale = 4;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;

      // Kırpma
      const cropCanvas = document.createElement('canvas');
      const cropContext = cropCanvas.getContext('2d')!;
      const cropTop = 400;
      const cropBottom = 390;
      const cropHeight = canvas.height - cropTop - cropBottom;
      const cropWidth = canvas.width;

      cropCanvas.width = cropWidth;
      cropCanvas.height = cropHeight;

      cropContext.drawImage(canvas, 0, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
      const imgData = cropCanvas.toDataURL('image/png');
      canvasArray.push(imgData);

      const imgElement = document.createElement('img');
      imgElement.src = imgData;
      imgElement.style.width = '100%';
      imgElement.style.marginBottom = '20px';
      container?.appendChild(imgElement);
    }

    this.img = canvasArray;
    if (canvasArray != null) {
      this.pdfBuffer = true;
    }
    console.log('Kalan sayfalar yüklendi:', this.img);
  }

  /*onFileSelected2(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files ? fileInput.files[0] : null;
    this.img = [];
 
    const container = document.getElementById('pdf-container');
    if (container) {
      container.innerHTML = '';  // Eski görselleri temizle
    }
 
    if (file) {
      const reader = new FileReader();
 
      // Dosya okuma işlemi tamamlandığında bu fonksiyon çalışacak
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const typedArray = new Uint8Array(e.target?.result as ArrayBuffer);
        const arrayBuffer = e.target?.result as ArrayBuffer;
 
 
        // PDF dosyasını pdf.js ile açıyoruz
        pdfjsLib.getDocument(typedArray).promise.then(pdf => {
          this.pdfDoc = pdf;  // PDF dokümanını tutuyoruz
          this.totalPages = pdf.numPages;  // Toplam sayfa sayısını alıyoruz
          const canvasArray: string[] = [];  // Her sayfa için Base64 görseli tutacak dizi
          if (container) {
            container.innerHTML = '';
          }
          // Sayfa render işlemi
          const renderPage = (pageNum: number) => {
            pdf.getPage(pageNum).then(page => {
              const scale = 4.0;  // Sayfa ölçeği
              const viewport = page.getViewport({ scale: scale });
 
              // Canvas oluşturuyoruz
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d')!;
              canvas.height = viewport.height;
              canvas.width = viewport.width;
              
              this.showPdfInIframe(arrayBuffer);
 
              // Sayfayı canvas'a render ediyoruz
              page.render({
                canvasContext: context,
                viewport: viewport
              }).promise.then(() => {
                // Kırpma için yeni canvas oluştur
                const cropCanvas = document.createElement('canvas');
                const cropContext = cropCanvas.getContext('2d')!;
 
                const cropTop = 340;    // üstten kırpılacak px
                const cropBottom = 390; // alttan kırpılacak px
                const cropLeft = 0;    // soldan kırpılacak px
                const cropRight = 0;   // sağdan kırpılacak px
 
                const cropHeight = canvas.height - cropTop - cropBottom;
                const cropWidth = canvas.width - cropLeft - cropRight;
 
                cropCanvas.width = cropWidth;   // genişlik aynı kalsın
                cropCanvas.height = cropHeight;    // yükseklik kırpılmış olsun
 
                cropContext.drawImage(
                  canvas,
                  cropLeft, cropTop,                 // kaynak başlangıç (x=0, y=cropTop)
                  cropWidth, cropHeight,      // kaynak boyut: kırpılmış genişlik & yükseklik
                  0, 0,                       // hedef başlangıç
                  cropWidth, cropHeight       // hedef boyut
                );
 
                const imgData = cropCanvas.toDataURL('image/png');
                canvasArray[pageNum - 1] = imgData;
 
                if (canvasArray.length === this.totalPages) {
                  this.img = canvasArray;
                  this.openAllPagesInNewTabs(canvasArray);
                }
              });
            });
          };
 
          // Sayfaları sırayla işliyoruz
          for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
            renderPage(pageNum);
          }
        });
      };
 
      reader.readAsArrayBuffer(file);  // Dosyayı okuyoruz
    }
  }*/

  showPdfInIframe(pdfBuffer: ArrayBuffer) {
    const blob = new Blob([pdfBuffer], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const iframeContainer = document.getElementById("pdf-container");
    if (iframeContainer) {
      iframeContainer.innerHTML = `
        <iframe style="width:100%;height:800px;border: none;" src="${url}"></iframe>
      `;
    }
  }


  openAllPagesInNewTabs(imgDataArray: string[]) {
    const container = document.getElementById('pdf-container');  // Sayfada görselleri ekleyeceğimiz container

    imgDataArray.forEach(imgData => {
      const imgElement = document.createElement('img');
      imgElement.src = imgData;  // Base64 görseli img etiketi kaynağı olarak ayarlıyoruz
      imgElement.style.width = '100%';  // Görselin genişliğini sayfaya uyacak şekilde ayarlıyoruz
      imgElement.style.marginBottom = '20px';  // Sayfalar arasında boşluk bırakıyoruz
      container?.appendChild(imgElement);  // Görseli container'a ekliyoruz
    });
  }

  async pdfDetail(isSave: boolean) {
    this._coreConfigService.setConfig({ emitEvent: true });
    console.log(this.coreConfig);
    this.getByIdLogo(this.selectedAcradtionOrganizationId)
    const logoKey = Object.keys(CalibrationlogoEnum);
    const key = logoKey[this.selectedAcradtionOrganizationId - 1];
    Object.keys(this.coreConfig.akraditasyonCompanies).find(k => k === key);
    const value = this.coreConfig.akraditasyonCompanies[key];
    console.log(value);
    if (this.calibration2.akraditationCompanyFile) {
      if (!this.calibration2.akraditationCompanyFile.startsWith('data:image/png;base64,')) {
        this.calibration2.akraditationCompanyFile = 'data:image/png;base64,' + this.calibration2.akraditationCompanyFile;
      }
    }

    const issueDate: Date = new Date(this.calibration2.calibrationDate);
    const year = issueDate.getFullYear().toString().slice(-2); // Yılın son iki basamağını al
    const month = (issueDate.getMonth() + 1).toString().padStart(2, '0'); // Ayı iki basamağa tamamla
    const formattedDate = month + '.' + year;

    let finalCertificateNo = this.certificateNumber;

    if (!this.certificateForm.value.isPrivateResiveNo) {
      // "-R" ile başlayan son eki kaldır
      finalCertificateNo = this.certificateNumber.replace(/-R\d+$/, '');
    }

    const headerBilgi: headerBilgileri = {
      akraditationNo: value ?? '',
      akraditationFirma: Number(this.selectedAcradtionOrganizationId),
      acradtionOrganizationId: Number(this.selectedAcradtionOrganizationId),
      certificateNo: finalCertificateNo,
      certificateTarih: formattedDate,
      firmaAdi: this.calibration2.akraditationCompany,
      firmaAdresi: this.calibration2.akraditationCompanyAddres ?? '',
      firmaLogo: this.calibration2.akraditationCompanyFile ?? '',
    }

    const calibrationDate = new Date(this.calibration2.calibrationDate);
    const formattedCalibrationDate = `${calibrationDate.getDate().toString().padStart(2, '0')}.${(calibrationDate.getMonth() + 1).toString().padStart(2, '0')}.${calibrationDate.getFullYear()}`;

    const confirmedPerson = this.calCompanyPerson.find(p => p.id == this.certificateForm.value.personId);

    const calibrationData: CalibrationData = {
      deviceOwner: this.calibration.deliveryDevice?.certficateCompany,
      address: this.calibration.companyAddress ?? '',
      orderNumber: this.calibration2.transactionManagementNo,
      deviceName: this.calibration2.deviceName,
      manufacturer: this.calibration2.deviceBrand,
      modelType: this.calibration2.deviceModel,
      serialNumber: this.calibration2.deviceSeriNo + '\t' + (this.calibration2.deviceInventoryNumber != null ? '/' : '') + '\t' + (this.calibration2.deviceInventoryNumber ?? ''),
      calibrationDate: formattedCalibrationDate,
      certificateNo: this.certificateNumber,
      firstPageDescription: this.selectedAcradtionOrganizationId == 3 ? this.calibration2.firstPageDescriptions[2].description : this.calibration2.firstPageDescriptions[0].description,
      kalYapan: this.calibration2.person,
      onaylayan: confirmedPerson.fullName ?? '',
      certificatePageNumber: this.pageCount + this.totalPages,
      firtsPageFooterDescription: this.calibration2.firstPageDescriptions[1].description,
      place: this.calibration2.devicePlace ?? ''
    };

    const referenceString = (this.calibration2.deviceReferenceMin && this.calibration2.deviceReferenceMax && this.calibration2.deviceReferenceUnitType)
      ? `${this.calibration2.deviceReferenceMin}-${this.calibration2.deviceReferenceMax} ${this.calibration2.deviceReferenceUnitType}`
      : '-';
    const deliveryDate = new Date(this.calibration2.deliveryDate);

    const formattedDeliveryDate = `${deliveryDate.getDate().toString().padStart(2, '0')}.${(deliveryDate.getMonth() + 1).toString().padStart(2, '0')}.${deliveryDate.getFullYear()}`;

    const references: Reference[] = this.calibration2.calibrationReferencesDevices.map(device => ({
      deviceName: device.deviceName,
      brand: device.brandName,  // 'brandName' -> 'brand'
      model: device.modelName,  // 'modelName' -> 'model'
      serialNumber: device.seriNo,  // 'seriNo' -> 'serialNumber'
      certificateNumber: device.referenceDeviceMovement.calibrationNo,  // 'calibrationNo' -> 'certificateNumber'
      calibrationDate: this.formatDate(device.referenceDeviceMovement.calibrationDate),  // Format edilmiş tarih
      tracebility: device.referenceDeviceMovement.traceability  // 'traceability' -> 'tracebility'
    }));

    const calibrationDataPage2: CalibrationPage2 = {
      device: {
        deviceName: this.calibration2.deviceName,
        serialNo: this.calibration2.deviceSeriNo,
        deviceNumber: this.calibration2.deviceInventoryNumber ?? '-',
        location: this.calibration2.devicePlace ?? '-',
        brand: this.calibration2.deviceBrand,
        type: this.calibration2.deviceModel,
        range: this.isPlace ? 'Yerinde' : formattedDeliveryDate, // referenceString,
        resolution: this.calibration2.deviceResolution ?? '-',
        incomingDateOfDeviceLaboratory: this.calibrationAddress, //this.calibration2.isPlace ? 'Yerinde' : formattedDeliveryDate,
        visualFunctionInspectionDevice: this.certificateForm.value.visualAndFunctional ? 'Uygun' : 'Uygun Değil'
      },
      references: references,
      evironmentalConditions: this.calibration2.enviromentalContents,
      calibrationMethod: this.calibration2.calibrationMethodDescription,
      remarks: this.calibration2.procedureDescription,
      compliance: this.calibration2.conformityDeclartion,
      measurement: this.calibration2.measurementUncertaintyDescription,
      measurementUncertainty: this.calibration2.measurementUncertaintyDescription,
      description: this.calibration2.calibrationMethodDescription,
      reviseDescription: this.certificateForm.value.isPrivateResiveDescription
        ? this.certificateForm.value.reviseDescription
        : null
    };

    await this.generatePDF(headerBilgi, calibrationData, calibrationDataPage2, isSave);
  }

  formatDate(date: string): string {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Aylar 0'dan başladığı için +1 yapıyoruz
    const year = newDate.getFullYear();
    return `${day}.${month}.${year}`;  // Gün.Ay.Yıl formatı
  }

  selectedFile: File | null = null;
  saveFilePath: string | null = null;
  onFileSelected2(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    this.selectedFile = fileInput.files?.[0] ?? null;
    console.log(this.selectedFile);
    const uploadedFileName = this.selectedFile.name.replace(/\.[^/.]+$/, '');

    // Beklenen dosya adı (uzantısız)
    console.log(this.certificateNumber);

    const certificateSuffix = this.certificateNumber
      ?.split('-')
      ?.pop();

    let fileName = null;
    if (this.calibration.deliveryDevice.seriNo != null)
      fileName = this.calibration.deliveryDevice.seriNo + "-" + this.calibration.deliveryDevice.code + "-" + this.calibration.deliveryDevice.deliveryCode;
    else
      fileName = this.calibration.deliveryDevice.code + "-" + this.calibration.deliveryDevice.deliveryCode;

    if (certificateSuffix) {
      fileName = `${fileName}-${certificateSuffix}`;
    }

    this.saveFilePath = fileName;

    if (uploadedFileName !== fileName) {
      this.toastrService.error(`${fileName} ismi ile kaydedilecektir`, 'Dosya Adı', {
        timeOut: 10000,
        closeButton: true,
        progressBar: true,
        toastClass: 'toast ngx-toastr',
      });
      //this.selectedFile = null;
    }
  }

  logo = null;
  getByIdLogo(number: number): string | null {
    console.log(number);
    const logos = Object.values(CalibrationlogoEnum);
    console.log(logos);
    this.logo = logos[number - 1] || null;
    console.log(this.logo);
    return this.logo;
  }

  async convertImageToBase64(url: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // CORS hatalarını önlemek için
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(null);
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = (err) => {
        console.error("Resim yüklenemedi!", url, err);
        reject(null);
      };
    });
  }


  measurementResultBase64: any = null;;

  async getCalibrationMeasurementResultBase64(path: string) {
    var result = await this.calibrationService.getCalibrationMeasurementResultBase64(path);
    console.log(result);
    if (result?.base64) {
      const pdfBase64 = result.base64;

      // 🔹 iframe için data URL
      const pdfDataUrl = `data:application/pdf;base64,${pdfBase64}`;

      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfDataUrl);
      this.isPdfDoc = true;
    }
    //await this.loadPdfFromBase64(this.measurementResultBase64);
  }

  async convertPdfPagesToImages(pdfBase64: string): Promise<any[]> {
    if (!pdfBase64) return [];

    const pdfData = atob(pdfBase64);
    const pdfContainer = document.getElementById('pdf-container');

    if (pdfContainer) {
      pdfContainer.innerHTML = '';
      const header = document.createElement('h3');
      header.textContent = 'Ölçüm Sonuçları PDF Önizlemesi';
      pdfContainer.appendChild(header);
    }

    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const numPages = pdf.numPages;
    const imagesArray: any[] = [];

    // 🔹 Yüksek kalite render
    const scaleFactor = 4.0;

    for (let i = 1; i <= numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: scaleFactor });

      // 🔹 TAM SAYFA CANVAS
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise;

      // 🔹 Önizleme (KESİLMEDEN)
      if (pdfContainer) {
        canvas.style.maxWidth = '100%';
        canvas.style.height = 'auto';
        canvas.style.border = '1px solid #ccc';
        canvas.style.margin = '10px 0';

        const pageHeader = document.createElement('h4');
        pageHeader.textContent = `Sayfa ${i}`;
        pdfContainer.appendChild(pageHeader);
        pdfContainer.appendChild(canvas);
      }

      // 🔹 Base64 image (pdfmake için)
      const base64Image = canvas.toDataURL('image/jpeg', 0.95);

      imagesArray.push({
        image: base64Image,
        width: 525,
        pageBreak: i < numPages ? 'after' : undefined
      });
    }

    return imagesArray;
  }


  customerSetting: GetCustomerSettingDetailDTO;
  async generatePDF(headerData: headerBilgileri, calibrationData: CalibrationData, calibrationPage2: CalibrationPage2, isSave: boolean = false) {
    await this.pdfFontService.loadFonts();

    // Convert image paths to Base64 asynchronously
    calibrationData.certificatePageNumber = this.pageCount + this.totalPages;
    // headerData.firmaLogo = await this.convertImageToBase64(headerData.firmaLogo) || '';
    this.customerSetting = await this.customerSettingService.getCustomerSettingDetail(1);
    console.log(this.pdfDoc);

    let akraditasyonFirma = '';
    if (headerData.akraditationFirma == 1) {
      if (this.customerSetting.turkakLogo != null)
        akraditasyonFirma = this.customerSetting.turkakLogo;
    } else if (headerData.akraditationFirma == 2) {
      if (this.customerSetting.nacLogo != null)
        akraditasyonFirma = this.customerSetting.nacLogo;
    }
    else if (headerData.akraditationFirma == 3) {
      if (this.customerSetting.traceabilityLogoPath != null)
        akraditasyonFirma = this.customerSetting.traceabilityLogoPath
    } else if (headerData.akraditationFirma == 4) {
      if (this.customerSetting.iasLogo != null)
        akraditasyonFirma = this.customerSetting.iasLogo
    }
    /* if (headerData.akraditationFirma == 1 || headerData.akraditationFirma == 2 || headerData.akraditationFirma == 3) {
       const akraditasyonLogoPath = this.getByIdLogo(headerData.akraditationFirma);
       akraditasyonFirma = await this.convertImageToBase64(akraditasyonLogoPath) || '';
     }*/

    if (this.selectProcedureId != null) {
      this.selectProcedure = this.kindProcedures?.find(p => p.id == this.selectProcedureId);
      console.log(this.selectProcedure);
    }


    // Document definition
    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [35, 215, 35, 90],
      defaultStyle: {
        font: 'RobotoSerif', // Using the custom font
      },
      background: (currentPage, pageSize) => {
        if (!this.calibration2.akraditationCompanyFile) return null;
        return {
          image: `${headerData.firmaLogo}`,
          width: 450,
          opacity: 0.1,
          absolutePosition: { x: 75, y: 350 }
        };
      },
      // Header for each page
      header: (currentPage, pageCount, pageSize) => {
        return this.getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData);
      },
      // Content of the document (multiple pages)
      content: [
        await this.createCalibrationPageContent(calibrationData, true),
        this.createCalibrationPage2(calibrationPage2),
        this.createCalibrationOtherPage(this.img)
      ],
      // Footer for each page
      footer: (currentPage, pageCount) => this.getFooterContent(currentPage, pageCount, calibrationData.firtsPageFooterDescription)
    }
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition as unknown as TDocumentDefinitions);

    console.log(this.certificateForm.value);

    if (isSave) {
      const expiryDate = new Date(this.certificateForm.value.expiryDate[0]);
      expiryDate.setHours(expiryDate.getHours() + 3);

      const issueDate = new Date(this.certificateForm.value.issueDate[0]);
      issueDate.setHours(issueDate.getHours() + 3);
      const data = await this.certificateService.updateCertificate({
        //  base64Data: base64Data,
        id: this.certificate.id,
        certificateNo: this.certificateForm.value.certificateNo,
        calibrationId: this.calibration2.id,
        expiryDate: expiryDate,
        issueDate: issueDate,
        personId: this.certificateForm.value.personId,
        status: 6,
        createCertificateRevise: {
          personId: _isPersonId,
          description: this.certificateForm.value.reviseDescription,
          certificateId: this.certificate.id,
          reviseDate: new Date(this.certificateForm.value.reviseDate[0]),
          certificateNo: this.reserveCert ? this.reserveCert.reservedCertificateNo : this.certificateForm.value.certificateNo,
          isEyeReviseNo: this.certificateForm.value.isPrivateResiveNo,
          isEyeDescription: this.certificateForm.value.isPrivateResiveDescription,
          is_MeasurementFile: this.selectedFile ? true : false
        }
      });
      if (data.status) {
        this.closeModal();
        this.certificateService.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }/*
      pdfDocGenerator.getBase64(async (base64Data) => {

      })*/
    } else {
      pdfDocGenerator.open();
    }
    // Generate and open the PDF
  }

  async convert() {
    if (!this.selectedFile) return;

    const toastRef = this.toastrService.info(
      'Ölçüm Sonucu yükleniyor...',
      'Lütfen bekleyiniz',
      {
        disableTimeOut: true, // 🔴 otomatik kapanmasın
        tapToDismiss: false,  // tıklayınca kapanmasın
        closeButton: false
      }
    );
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    const response$ = this.httpClientService.post(
      {
        controller: ControllerType.Deneme,
        action: 'convert',
      },
      formData
    );

    const response: any = await firstValueFrom(response$);
    console.log(response);
    // 🔴 Base64 → PDF iframe src
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `data:${response.contentType};base64,${response.base64}`
    );
    this.toastrService.clear(toastRef.toastId);
  }

  qrCodeBase64: string;

  async generateQRCode(certificateNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const url = `${this.backendUrl}api/Certificates/verify/${this.calibration2.calibrationNo}-${certificateNo}.pdf`;
    try {
      // QR kodunu Base64 formatında oluşturuyoruz
      const qrCanvas = document.createElement('canvas');
      await QRCode.toCanvas(qrCanvas, url, { width: 250 });

      // 2️⃣ Yeni bir canvas oluştur (QR + metin için)
      const finalCanvas = document.createElement('canvas');
      const ctx = finalCanvas.getContext('2d')!;
      const qrSize = qrCanvas.width;
      const textHeight = 40; // alt boşluk
      finalCanvas.width = qrSize;
      finalCanvas.height = qrSize + textHeight;

      // 3️⃣ QR kodu çiz
      ctx.drawImage(qrCanvas, 0, 0);

      // 4️⃣ Metni çiz
      ctx.font = 'bold 32px Arial';
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(certificateNo, qrSize / 2, qrSize + 30);

      // 5️⃣ Base64 çıktısı al
      this.qrCodeBase64 = finalCanvas.toDataURL('image/png');
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }

  async createCalibrationPageContent(calibrationData: CalibrationData, pageBreak: boolean) {
    let firstPageDescriptionToHtml = htmlToPdfmake(calibrationData.firstPageDescription);
    firstPageDescriptionToHtml = this.applyDefaultFontSize(firstPageDescriptionToHtml, 8, 7);

    //const seal = await this.convertImageToBase64('/assets/logo/muhur.png').catch(err => console.log(err));
    const imza1 = await this.convertImageToBase64('/assets/logo/e-imza.png').catch(err => console.log(err));
    let seal = this.customerSetting.stampImage;
    await this.generateQRCode(calibrationData.certificateNo);
    return [
      {
        table: {
          widths: ['30%', '70%'], // İlk sütun başlık, ikinci sütun veri
          body: [
            [{ text: 'Cihaz Sahibi / Adresi', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceOwner}`, fontSize: 9 }],
            [{ text: 'Customer / Address', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, { text: `${calibrationData.address}`, fontSize: 7 }],

            [{ text: 'Sipariş Numarası', bold: true, fontSize: 9 }, { text: `${calibrationData.orderNumber ?? '-'}`, fontSize: 9 }],
            [{ text: 'Order No', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Cihaz', bold: true, fontSize: 9 }, { text: `${calibrationData.deviceName}`, fontSize: 9 }],
            [{ text: 'Device', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'İmalatçı', bold: true, fontSize: 9 }, { text: `${calibrationData.manufacturer}`, fontSize: 9 }],
            [{ text: 'Brand', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Model / Tip', bold: true, fontSize: 9 }, { text: `${calibrationData.modelType}`, fontSize: 9 }],
            [{ text: 'Type', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Seri Numarası / Envanter No', bold: true, fontSize: 9 }, { text: `${calibrationData.serialNumber}`, fontSize: 9 }],
            [{ text: 'Serial Number / Inventory Number', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Kalibrasyon Tarihi', bold: true, fontSize: 9 }, { text: `${calibrationData.calibrationDate}`, fontSize: 9 }],
            [{ text: 'Date of Calibration', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            [{ text: 'Sertifika Sayfa Sayısı', bold: true, fontSize: 9 }, { text: `${calibrationData.certificatePageNumber}`, fontSize: 9 }],
            [{ text: 'Number of Pages of The Certificate', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],

            //[{ text: 'Bulunduğu Yer', bold: true, fontSize: 9 }, { text: `${calibrationData.place}`, fontSize: 9 }],
            //[{ text: 'Location Of Equipment', italics: true, fontSize: 7, margin: [0, 0, 0, 2] }, {}],
          ]
        },
        layout: 'noBorders', // Tablo çizgilerini kaldırdım
        margin: [0, -12, 0, 1],
      },
      {
        stack: [firstPageDescriptionToHtml],
        margin: [0, 5, 0, 10]
      },

      {
        table: {
          widths: ['25%', '25%', '25%', '25%',],
          body: [
            [{ text: "Mühür", bold: true, fontSize: 8, alignment: 'center' }, { text: 'Yayımlanma Tarihi', bold: true, fontSize: 8, alignment: 'center' }, { text: "Kalibrasyon Yapan", bold: true, fontSize: 8, alignment: 'center' }, { text: "Onaylayan", bold: true, fontSize: 8, alignment: 'center' },],
            [{ text: "Seal", fontSize: 6, alignment: 'center', italics: true }, { text: 'Issue Date', fontSize: 8, alignment: 'center', italics: true }, { text: "Calibrated by", fontSize: 6, alignment: 'center', italics: true }, { text: "Approval", fontSize: 6, alignment: 'center', italics: true }],
            [
              { image: seal, fit: [85, 85], alignment: 'center' },
              { text: `${(this.certificateForm.value.issueDate[0]).toLocaleDateString('tr-TR')}`, fontSize: 10, alignment: 'center', marginTop: 15 },
              [
                { text: calibrationData.kalYapan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                { text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000' }
              ],
              [
                { text: calibrationData.onaylayan, fontSize: 10, alignment: 'center', marginBottom: 5, marginTop: 15 },
                { text: 'E-imzalıdır!', fontSize: 10, bold: true, italics: true, alignment: 'center', color: '#FF0000' },
                {
                  text: `${calibrationData.calibrationDate}`,
                  fontSize: 8,
                  alignment: 'center'
                }
              ],
            ]
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 0],
      },
      pageBreak ? { text: '', pageBreak: 'after' } : { text: '' },
    ];
  }

  applyDefaultFontSize(obj: any, normalFontSize: number = 7, smallFontSize: number = 5) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item, normalFontSize, smallFontSize));
    } else if (typeof obj === "object" && obj !== null) {
      // If the object contains text and doesn't have fontSize defined
      if (obj.text && !obj.fontSize) {
        // Apply the normal font size by default
        obj.fontSize = normalFontSize;
      }

      // Adjust the font size if 'ql-size-small' is present in style
      if (obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = smallFontSize; // Apply small font size
      }

      // If the object has margin, reduce it by 10%
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1);
      }

      // Recursively apply the function to nested properties
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key], normalFontSize, smallFontSize);
      });
    }
    return obj;
  }

  createCalibrationPage2(calibrationPage2: CalibrationPage2) {
    let calibrationText = htmlToPdfmake(calibrationPage2.description);
    calibrationText = this.applyDefaultFontSize(calibrationText);

    let remaksToHtml = htmlToPdfmake(calibrationPage2.remarks);
    remaksToHtml = this.applyDefaultFontSize(remaksToHtml);

    let complianceToHtml = htmlToPdfmake(calibrationPage2.compliance);
    complianceToHtml = this.applyDefaultFontSize(complianceToHtml);

    let measurementToHtml = htmlToPdfmake(calibrationPage2.measurement);
    measurementToHtml = this.applyDefaultFontSize(measurementToHtml);
    return [
      {
        stack: [
          {
            text: [
              {
                text: "Kalibre Edilen Cihaz /", bold: true, fontSize: 10,
              },
              {
                text: "Device to be calibrate", fontSize: 8, italics: true
              },
            ],
            margin: [0, 0, 0, 0]
          },
          {
            columns: [
              {
                table: {
                  widths: ['50%', '50%'], // İki sütunlu tablo
                  body: [
                    // İlk tablo: Cihaz bilgileri
                    [{ text: 'Cihaz Adı / Device Name :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceName}`, fontSize: 8 }],
                    [{ text: 'Seri Numarası / Serial No :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.serialNo}`, fontSize: 8 }],
                    [{ text: 'Cihaz No / Device No :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.deviceNumber}`, fontSize: 8 }],
                    [{ text: 'Bulunduğu Yer / Location :', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.location}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              {
                table: {
                  widths: ['50%', '50%'], // İkinci tablo: Model ve ölçüm bilgileri
                  body: [
                    [{ text: 'Marka / Brand', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.brand}`, fontSize: 8 }],
                    [{ text: 'Model / Model', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.type}`, fontSize: 8 }],
                    [{ text: 'Çözünürlük / Resolution', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.resolution}`, fontSize: 8 }],
                    [{ text: 'Lab. Kabul Tarihi \ Lab. Date', bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.range}`, fontSize: 8 }],
                  ]
                },
                layout: 'noBorders', // Tablo çizgilerini kaldırdım
                margin: [0, 5, 0, 0],
              },
              // Tabloların altındaki ek bilgiler
            ],
          },
          {
            table: {
              widths: ['25%', '75%'],
              body: [
                [{ text: `Cihazın Kalibrasyon Yapıldığı Yer`, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.incomingDateOfDeviceLaboratory}`, fontSize: 8 }],
                [{ text: `Görsel ve Fonksiyonel Kontrol    `, bold: true, fontSize: 8 }, { text: `${calibrationPage2.device.visualFunctionInspectionDevice}`, fontSize: 8 }]
              ],
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyonda Kullanılan Cihazlar /", bold: true, fontSize: 10 },
                      { text: "References used in calibration", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ['27%', '13%', '13%', '14%', '10%', '10%', '13%'], // 7 sütun için genişlikleri belirledim
                  body: [
                    [{ text: 'Cihaz Adı', fontSize: 8, bold: true }, { text: 'Marka', fontSize: 8, bold: true }, { text: 'Model', fontSize: 8, bold: true }, { text: 'Seri No', fontSize: 8, bold: true }, { text: 'Sertfika No', fontSize: 8, bold: true }, { text: 'Kal. Tarihi', fontSize: 8, bold: true }, { text: 'İzlenebilirlik', fontSize: 8, bold: true }],
                    [{ text: 'Device Name', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Brand', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Model', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Serial No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Certificate No', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Cal. Date', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }, { text: 'Tracebility', fontSize: 7, italics: true, margin: [0, 0, 0, 5] }],
                    ...calibrationPage2.references.map(ref => [
                      { text: ref.deviceName, fontSize: 8 },
                      { text: ref.brand, fontSize: 8 },
                      { text: ref.model, fontSize: 8 },
                      { text: ref.serialNumber, fontSize: 8 },
                      { text: ref.certificateNumber, fontSize: 8 },
                      { text: ref.calibrationDate, fontSize: 8 },
                      { text: ref.tracebility, fontSize: 8 } // İzlenebilirlik için örnek veri (isteğe bağlı)
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }

            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Çevre Şartları /", bold: true, fontSize: 10 },
                      { text: "Environment Conditions", fontSize: 8, italics: true },
                    ]
                  }
                ],
                margin: [0, 10, 0, 0],
              },
              {
                table: {
                  widths: ["*", "*", "*"],
                  body: [
                    [{ text: "Tür / Kind", bold: true, fontSize: 8 }, { text: "Başlangıç / Start", bold: true, fontSize: 8 }, { text: "Bitiş / End", bold: true, fontSize: 8 }],
                    ...(calibrationPage2.evironmentalConditions || []).map(ref => [
                      { text: ref.name || "-", fontSize: 7 },
                      { text: ref.start || "-", fontSize: 7 },
                      { text: ref.end || "-", fontSize: 7 },
                    ])
                  ],
                },
                layout: 'noBorders',
                margin: [0, 5, 0, 0],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Kalibrasyon Metodu /", bold: true, fontSize: 10 },
                      { text: "Calibration Method", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [calibrationText],
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Açıklama /", bold: true, fontSize: 10 },
                      { text: "Remarks", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [remaksToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Uygunluk Beyanı /", bold: true, fontSize: 10 },
                      { text: "Statement Of Complance", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [complianceToHtml]
              }
            ]
          },
          {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Ölçüm Belirsizliği /", bold: true, fontSize: 10 },
                      { text: "Measurement Uncertaintily", fontSize: 8, italics: true },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                stack: [measurementToHtml]
              }
            ]
          },
          calibrationPage2.reviseDescription ? {
            stack: [
              {
                columns: [
                  {
                    text: [
                      { text: "Revize Gerekçesi /", bold: true, fontSize: 10 },
                      {
                        text: "Justification Revision", fontSize: 8, italics: true
                      },
                    ]
                  },
                ],
                margin: [0, 10, 0, 0],
              },
              {
                text: calibrationPage2.reviseDescription, fontSize: 8
              }
            ]
          } : { text: '' },
        ],
        marginTop: -100
      },
      // Sayfa sonu eklemeleri (isteğe bağlı)
      { text: '', pageBreak: 'after' }, // Eğer sayfa sonu gerekiyorsa, sayfa kesme ekleyebilirsiniz
    ];
  }

  createCalibrationOtherPage(imgData: string[]) {
    const pageContent = [];
    // Sayfa başına bir görsel ekliyoruz ve her sayfada bir kırılma ekliyoruz.
    for (let i = 0; i < imgData.length; i++) {
      pageContent.push({
        image: imgData[i],
        alignment: 'center',
        fit: [580, 1400], // sayfaya sığacak şekilde
        margin: [0, 0, 0, 0], // Görsel ile header arasına boşluk bırakabiliriz
        absolutePosition: { x: this.pdfBuffer == true ? 20 : 60, y: this.pdfBuffer == true ? 110 : 100 }, // Y konumunu her sayfa için ayarlayabilirsiniz
        pageBreak: i < imgData.length - 1 ? 'after' : undefined // Son görselden sonra sayfa kırılması ekliyoruz
      });
    }
    return pageContent;
  }

  // Header content function
  getHeaderContent(currentPage, pageCount, akraditasyonFirma, headerData: headerBilgileri,) {
    return {
      stack: [
        {
          columns: [
            { ...this.getLeftColumn(headerData, currentPage, pageCount), width: '25%' },
            {
              ...this.getCenterColumn(headerData, currentPage), width: '52%' // sağdaki tabloya 2 birim boşluk bırak
            },
            headerData.acradtionOrganizationId != 3 ? {
              ...this.getOtherLogoColumn(headerData, currentPage),             // 3️⃣ diğer logo
              width: '*',
              margin: [0, 0, 2, 0], // sağdaki tabloya 2 birim boşluk bırak
            } :
              {
                text: '',
                width: '*',
                margin: [0, 0, 2, 0],
              },
            {
              ...this.getRightColumn(akraditasyonFirma, headerData.akraditationNo, headerData.certificateNo, headerData.certificateTarih, currentPage, headerData.firmaAdi?.split(' ')[0], this.selectedAcradtionOrganizationId),
              width: 'auto',
              alignment: 'right'

            }
          ],
          margin: [35, 12, 35, 5],
        },
        {
          text: `Sayfa (Page): ${currentPage} / ${pageCount}`,
          fontSize: 8,
          alignment: 'left',
          margin: [35, 2, 0, 0]   // soldan 35 px, üstten 5 px boşluk
        },
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
      ],
    };
  }

  // Left column content
  getLeftColumn(headerData, currentPage, totalPages) {
    const logoStack: any[] = [];

    // 🔹 1. sayfada firma logosu
    if (headerData.firmaLogo && currentPage === 1) {
      logoStack.push({
        image: headerData.firmaLogo,
        fit: [150, 150],
        margin: [0, -20, 0, 0],        // sola 0, üste -20, sağa 0, alta 0
        alignment: 'left'
      });

      // 🔹 QR Code logonun hemen altına
      if (this.qrCodeBase64) {
        logoStack.push({
          image: this.qrCodeBase64,
          //width:150,
          fit: [75, 75],
          margin: [20, 5, 0, 0],         // sola 0, üste 5, sağa 0, alta 0
          alignment: 'right'
        });
      }
    }

    return {
      stack: logoStack,
      alignment: 'left',
      minHeight: 100,
      margin: [0, 25, 0, 0]             // genel üst boşluk → 25
    };
  }


  // Center column content
  getCenterColumn(headerData, currentPage) {
    return {
      stack: [
        {
          noWrap: false,              // satır kırılabilsin
          text: `${headerData.firmaAdi}`,
          italics: true,
          bold: true,
          fontSize: 12,
          lineHeight: 1.1,
          margin: [15, headerData.firmaAdi.length && currentPage != 1 > 30 ? 10 : 20, 2, currentPage != 1 ? 10 : 0]
        },
        currentPage == 1 ? { text: `${headerData.firmaAdresi}`, italics: true, fontSize: 10, marginTop: 10, marginLeft: 10 } : { text: '' },

        currentPage == 1 ? { text: "KALİBRASYON SERTİFİKASI", bold: true, fontSize: 12, margin: [0, 25, 0, 0] } : { text: '' },
        currentPage == 1 ? { text: "Calibration Certificate", italics: true, fontSize: 8 } : { text: '' },
      ],

      alignment: 'center',
      marginTop: 20,
      marginLeft: 10
    };
  }

  getOtherLogoColumn(headerData, currentPage) {
    const otherLogoStack: any[] = [];
    if (this.customerSetting.otherLogo && currentPage === 1) {
      otherLogoStack.push({
        image: this.customerSetting.otherLogo,
        fit: [75, 90],
        alignment: 'rigth',
        margin: [0, 0, 0, 0]
      });
    } else {
      otherLogoStack.push({ text: '', width: 90, height: 90, opacity: 0 });
    }

    return {
      stack: otherLogoStack,
      alignment: 'rigth',
      minHeight: 100
    };
  }


  // Right column content
  getRightColumn(
    akraditasyonFirma: string,
    akraditationNo: string,
    certificateNo: string,
    certificateTarih: string,
    currentPage: number,
    companyName: string,
    akradetionNumber: number
  ) {
    const rightStack: any[] = [];
    akraditationNo = this.customerSetting.accreditationNo;
    this.certificateFirstNo = this.customerSetting.certificatePrefix;

    // ✅ 1. Üstte logo
    if (currentPage === 1 && akraditasyonFirma) {
      rightStack.push({
        image: akraditasyonFirma,
        witdh: 85,
        height: 85,
        fit: [75, 90],
        alignment: 'center',
        margin: [0, 5, 0, 0]
      });
    } else {
      // Sayfa 1 değilse boş alan koru
      rightStack.push({ text: '', width: 100, height: 100, opacity: 0 });
    }

    // ✅ 2. Turkak QR özel durumu
    if (this.coreConfig.isCalibratedTurkak === true && akradetionNumber === 1 && currentPage === 1) {
      rightStack.push({
        image: this.turkakQrBase64,
        fit: [65, 65],
        alignment: 'center',
        margin: [0, 5, 0, 0]
      });
      // Akreditasyon numarasındaki tüm '-' karakterlerini kaldır
      const revizeText = akraditationNo.slice(3).replace(/-/g, '') + '-' + certificateTarih + '-' + certificateNo;
      //this.certificationBodyDocumentNumber = revizeText;
      rightStack.push({
        //text: revizeText,
        text: this.certificationBodyDocumentNumber,
        fontSize: 7,
      });
    } else {
      // ✅ 3. Diğer durumlar – tabloyu koru
      rightStack.push({
        table: {
          widths: [55],
          body: [
            ...(akradetionNumber !== 3
              ? [[{ text: akraditationNo, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]
              : [[{ text: companyName?.toUpperCase(), alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]]),
            [{ text: `${this.certificateFirstNo}${certificateNo}`, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }],
            [{ text: certificateTarih, alignment: 'center', fontSize: 7, bold: true, margin: [0, 2] }]
          ]
        },
        marginTop: 10,
        marginLeft: 0
      });
    }

    return {
      stack: rightStack,
      alignment: 'right',
      minHeight: 100
    };
  }


  // Footer content function
  getFooterContent(currentPage, pageCount, firstPageFooterDescription) {
    if (currentPage > 2) {
      return {};
    }
    console.log(firstPageFooterDescription);
    let firstPageFooterDescriptionToHtml = htmlToPdfmake(firstPageFooterDescription);
    firstPageFooterDescriptionToHtml = this.applyDefaultFontSize(firstPageFooterDescriptionToHtml, 8, 8);
    // İlk sayfa için footer içeriğini ayarlarken margin ve padding ekliyoruz.
    return {
      stack: [
        // Footer'da bir çizgi ekliyoruz
        {
          canvas: [{ type: 'line', x1: 35, y1: 0, x2: 565, y2: 0, lineWidth: 1 }],
        },
        {
          stack: [
            firstPageFooterDescriptionToHtml,
            ...(this.selectProcedure ? [{ text: this.selectProcedure.formNo, fontSize: 8 }] : [])
          ],
          margin: [35, 10, 35, 60], // Alt margin'ini biraz daha azaltarak daha fazla alan bırakıyoruz

          fontSize: 8, // Font boyutunu küçültüyoruz
        }

      ],
      margin: [0, -10, 0, 0]
    };
  }

  resetCertificateNumber() {
    this.certificateNumber = null;
  }
}